import { render } from "./ScrollToTop.vue?vue&type=template&id=c27ae3d6"
const script = {}

import exportComponent from "/var/www/retail.interapptive.media/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__